import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  allOrders: [],
  pendingOrders: [],
  closedOrders: [],
  cancelOrders: [],
  loading: false,
  error: null,
};

const ordersSlice = createSlice({
  name: "orders",
  initialState,
  reducers: {
    setOrders(state, action) {
      // Sort by created_at (newest first)
      const sorted = Array.from(action.payload)
        .slice()
        .sort((a, b) => new Date(b.created_at) - new Date(a.created_at));

      // Keep only latest 50
      state.allOrders = sorted.slice(0, 50);
    },
    setPendingOrders(state, action) {
      state.pendingOrders = action.payload;
    },
    setClosedOrders(state, action) {
      const sorted = Array.from(action.payload)
        .slice()
        .sort((a, b) => new Date(b.closed_at) - new Date(a.closed_at));

      state.closedOrders = sorted.slice(0, 50);
    },
    setCancelOrders(state, action) {
      state.cancelOrders = action.payload;
    },
    addOrder(state, action) {
      const { type, payload } = action.payload;

      if (type === "position_closed") {
        state.closedOrders.unshift(payload);
        state.closedOrders = state.closedOrders.slice(0, 50); // ✅ limit to 50
      } else if (type === "order_cancelled") {
        state.cancelOrders.unshift(payload);
        state.cancelOrders = state.cancelOrders.slice(0, 50); // ✅ limit
      } else if (type === "order_placed") {
        state.allOrders.unshift(payload);
        state.allOrders = state.allOrders.slice(0, 50); // ✅ trim all orders

        if (payload.status === "pending") {
          state.pendingOrders.unshift(payload);
          // state.pendingOrders = state.pendingOrders.slice(0, 50); // ✅ trim
        }
      }
    },
    cancelOrder(state, action) {
      const id = action.payload;
      state.pendingOrders = state.pendingOrders.filter(
        (order) => order.id !== id
      );
      state.allOrders = state.allOrders.map((order) =>
        order.id === id ? { ...order, status: "cancelled" } : order
      );
    },
    fillOrder(state, action) {
      const orderId = action.payload.order_id || action.payload;
      state.allOrders = state.allOrders.map((order) =>
        order.id === orderId ? { ...order, status: "filled" } : order
      );
      state.pendingOrders = state.pendingOrders.filter(
        (order) => order.id !== orderId
      );
    },
    updateOrderStatus(state, action) {
      const { order_id, status } = action.payload;
      state.allOrders = state.allOrders.map((order) =>
        order.id === order_id ? { ...order, status } : order
      );
    },
  },
});

export const {
  setOrders,
  setPendingOrders,
  setClosedOrders,
  setCancelOrders,
  addOrder,
  cancelOrder,
  fillOrder,
  updateOrderStatus,
} = ordersSlice.actions;

export default ordersSlice.reducer;
